import { A11y } from './utils';

const accordion = () => {
  const $ = jQuery;
  const $accordionWrapper = $('.accordion-wrapper');

  const toggleHandler = function (e, _this = this) {
    const $thisAccordion = $(_this);
    const $thisAccordionWrapper = $thisAccordion.find('.accordion-float-wrapper');
    const $thisAccordionHeader = $(e.target);
    const $thisAccordionContent = $(_this).children('.accordion-content');
    if ($thisAccordionHeader.hasClass('accordion-float-wrapper') || ($thisAccordionHeader.parents('.accordion-float-wrapper').length > 0)) {
      if ($(_this).hasClass('accordion-variant-b')) {
        $thisAccordion.toggleClass('accordion-wrapper-opened');
        $thisAccordionWrapper.attr('aria-expanded', $thisAccordionWrapper.attr('aria-expanded') !== 'true');
        $thisAccordionContent.attr('aria-hidden', $thisAccordionContent.attr('aria-hidden') !== 'true').slideToggle();
      } else {
        if (!$thisAccordion.hasClass('accordion-wrapper-opened')) {
          const $prevOpenedAccordion = $('.accordion-wrapper-opened');
          $prevOpenedAccordion.removeClass('accordion-wrapper-opened').children('.accordion-content').slideUp(400, () => {
            const elementPosition = _this.getBoundingClientRect() || {};
            const navHeight = $('nav').height() || 0;
            if (elementPosition.top < navHeight && _this.offsetTop > 0) {
              setTimeout(() => {
                $('html, body').animate({
                  scrollTop: _this.offsetTop - navHeight - 100
                }, 400);
              }, 0);
            }
          });
          $prevOpenedAccordion.find('.accordion-float-wrapper').attr('aria-expanded', false);
          $thisAccordion.addClass('accordion-wrapper-opened').children('.accordion-content')
            .attr('aria-hidden', false).slideDown();
        } else {
          $thisAccordion.removeClass('accordion-wrapper-opened').children('.accordion-content')
            .attr('aria-hidden', true).slideUp();
        }
        $thisAccordionWrapper.attr('aria-expanded', $thisAccordionWrapper.attr('aria-expanded') !== 'true');
      }
    }
  };

  if (!$accordionWrapper.hasClass('default-close')) {
    if ($accordionWrapper.hasClass('open-all-accordions')) {
      const $accordionWrapperHeader = $accordionWrapper.children('.accordion-float-wrapper');
      $accordionWrapper.toggleClass('accordion-wrapper-opened');
      $accordionWrapperHeader.attr('aria-expanded', true);
      $accordionWrapper.children('.accordion-content').attr('aria-hidden', false).slideToggle();
    } else {
      const $firstAccordionWrapper = $accordionWrapper.first();
      const $firstAccordionWrapperHeader = $firstAccordionWrapper.children('.accordion-float-wrapper');
      $firstAccordionWrapperHeader.attr('aria-expanded', true);
      $firstAccordionWrapper.toggleClass('accordion-wrapper-opened')
        .children('.accordion-content')
        .attr('aria-hidden', false)
        .slideToggle();
    }
  }

  $accordionWrapper.on('click', toggleHandler);

  A11y.onKeyDown(['space', 'enter'], $accordionWrapper, toggleHandler);

  $('.accordion-link').on('click', function (e) {
    e.stopPropagation();
  });
};
export { accordion };
